import React from 'react';
import PeppaLoader from '../spinners/PeppaLoader';

const TypingIndicator = () => {
  return (
    <div className="flex gap-4 justify-start animate-in slide-in-from-bottom-2 duration-300">
      <div className="w-8 h-8 bg-gradient-to-r from-primary to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
        <PeppaLoader />
      </div>
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl px-4 py-3 shadow-sm">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        <div className="text-xs text-gray-500 mt-2">
          Peppa AI réfléchit...
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator; 